// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingdingOutlinedSvg from "@fishx/icons-svg/es/asn/DingdingOutlined";
import FishxIcon from '../components/FishxIcon';

var DingdingOutlined = function DingdingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingdingOutlinedSvg
  }));
};

DingdingOutlined.displayName = 'DingdingOutlined';
export default React.forwardRef(DingdingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DingdingOutlined.js
// module id = 2413
// module chunks = 0